export default __webpack_public_path__ + "static/media/prana03.f2d92961.JPG";